class FormCheck {
  constructor(field) {
    this.field = field
    this.render()
  }

  render() {
    this.field.classList.add('form-check')
    this.field.querySelector('input').classList.add('form-check-input')
    this.field.querySelectorAll('span', 'label').forEach((label) => label.classList.add('form-check-label'))
  }
}

export default FormCheck
